import React from "react";

import { FormBuilder } from "shared/components";
import { IFormButtons } from "shared/types";
import { IStageCapacity } from "Venues/types";
import { fields, style, defaultValues as standardDefaultValues } from "./formData";

interface StageCapacityFormProps {
  isSubmitting?: boolean;
  hasError?: boolean;
  defaultValues?: Record<string, any>;
  buttons?: IFormButtons;
  submitMode?: "isDirty";
  resetForm?: boolean;
  inlineForm?: boolean;
  handleSubmit: (capacity: IStageCapacity) => void;
}

export const StageCapacityForm: React.FC<StageCapacityFormProps> = ({
  handleSubmit,
  hasError,
  defaultValues = standardDefaultValues,
  ...rest
}) => {
  return (
    <FormBuilder
      fields={fields}
      onSubmit={({ capacity }) => handleSubmit(capacity)}
      style={style}
      defaultValues={defaultValues}
      globalError
      apiErrorMessage={hasError}
      {...rest}
      dataTestId="capacity_form"
    />
  );
};
